import { useEffect } from 'react'
import DotsLoading from 'common-components/DotsLoading'
import { COLORS } from 'consts/colors'
import * as Styled from '../styled'
import { useSelector } from 'react-redux'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { dispatch } from 'store'
import VersionHistoryList from '../VersionHistoryList'
import VersionHistoryEmpty from '../VersionHistoryEmpty'

const VersionHistory = () => {
  const isLoading = useSelector(aiImageSelectors.isVersionHistoryLoading)
  const isLoaded = useSelector(aiImageSelectors.isVersionHistoryLoaded)
  const versionItems = useSelector(aiImageSelectors.versionHistoryItems)
  const activeMedia = useSelector(aiImageSelectors.aiImageOverlayData)

  const fetchId = activeMedia?.id

  // Fetch once per item entry. Re-entering the tab remounts this component,
  // which re-runs the effect and triggers a fresh API call.
  // When fetchId is non-numeric (e.g. pending regeneration hash after refresh),
  // the thunk will mark history as loaded-empty so the empty state renders.
  useEffect(() => {
    dispatch(aiImageThunks.getVersionHistory(fetchId ?? ''))
  }, [fetchId])

  const hasVersionData = versionItems.length > 0

  return (
    <Styled.AiImageHistoryContainer>
      {isLoading && !hasVersionData && (
        <DotsLoading dotColor={COLORS.primaryDark} size="small" />
      )}

      {!hasVersionData && !isLoading && isLoaded && <VersionHistoryEmpty />}

      {hasVersionData && <VersionHistoryList items={versionItems} />}
    </Styled.AiImageHistoryContainer>
  )
}

export default VersionHistory
